module.exports = __webpack_public_path__ + "img/ai-4.fc9abad6.jpg";